import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  Input,
  ViewChild,
} from '@angular/core';
import { IonPopover } from '@ionic/angular';
import { WorkplacesService } from '@services/index';
import { Workplace } from '@models/workplace.model';

@Component({
  selector: 'app-workplace',
  standalone: false,
  templateUrl: './workplace.component.html',
  styleUrls: ['./workplace.component.scss'],
})
export class WorkplaceComponent implements OnInit {
  @Input() public selectionDisabled = false;
  @Input() public workLocation: string;

  public triggerId = `workplace-trigger-${Math.random().toString(16).slice(2)}`;
  public workplaceKey: string | null = null;
  public workplaceValue: Workplace | null = null;

  private readonly NOT_INFORMED_KEY = '0';

  public validWorkplaces: Workplace[] = [];
  public allWorkplaces: Workplace[] = [];

  public selectedWorkplace: Workplace | null = null;
  public selectPlaceholder = 'Seleccionar';

  @Output() public newItemEvent = new EventEmitter<{ workplace: string }>();

  @ViewChild(IonPopover) private popover?: IonPopover;

  public constructor(private readonly workplacesService: WorkplacesService) {}

  public ngOnInit(): void {
    this.workplacesService.workplacesDetails$.subscribe(
      (workplaceList: Workplace[]): void => {
        this.allWorkplaces = workplaceList ?? [];

        this.validWorkplaces = this.allWorkplaces.filter(
          (wp: Workplace): boolean => wp.key !== this.NOT_INFORMED_KEY
        );

        this.setInitialValue();
      }
    );
  }

  private setInitialValue(): void {
    const found = this.allWorkplaces.find(
      (wp: Workplace): boolean => wp.key === this.workLocation
    );

    this.workplaceKey = found?.key ?? null;
    this.workplaceValue = found ?? null;
    this.selectedWorkplace = found ?? null;

    this.selectPlaceholder =
      found && found.key === this.NOT_INFORMED_KEY ? found.name : 'Seleccionar';
  }

  public selectWorkplace(workplace: Workplace): void {
    if (!workplace) return;

    this.workplaceKey = workplace.key;
    this.workplaceValue = workplace;
    this.selectedWorkplace = workplace;

    this.newItemEvent.emit({ workplace: workplace.key });

    this.popover?.dismiss();
  }

  public onWorkplaceSelect(ev: any): void {
    const key: string | undefined = ev?.detail?.value;
    if (!key) return;

    const selected = this.validWorkplaces.find(wp => wp.key === key);
    if (!selected) return;

    this.selectWorkplace(selected);
  }
}
